import serviciosV2Client from "../../../helpers/serviciosV2Client"

const ANALYTICS = "analytics"

const cleanParams = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  )

const baseFiltros = ({
  nitemisor, fecha_inicio, fecha_fin,
  campo_fecha, sucursal,
}) => cleanParams({
  nitemisor, fecha_inicio, fecha_fin,
  campo_fecha, sucursal,
})

/**
 * Detalle agregado por sucursal con impuestos por tipo, exentos y totales.
 * Acepta `incluir_comparativo=true` para devolver el bloque `comparativo`
 * (vs período anterior del mismo largo).
 */
export const getImpuestosSucursal = ({ incluir_comparativo, ...filtros }) =>
  serviciosV2Client.get(`${ANALYTICS}/impuestos-detalle-sucursal`, {
    params: cleanParams({
      ...baseFiltros(filtros),
      incluir_comparativo: incluir_comparativo ? "true" : undefined,
    }),
  })

/**
 * Detalle día por día con `tendencia_diaria` (serie graficable) y
 * desglose por sucursal por cada día.
 */
export const getImpuestosDiario = (filtros) =>
  serviciosV2Client.get(`${ANALYTICS}/impuestos-detalle-diario`, {
    params: baseFiltros(filtros),
  })

/**
 * Descarga el Excel ejecutivo (9 hojas) generado por el back con
 * portada, por sucursal, detalle, por día, detalle diario, por familia,
 * top, tendencia y auditoría. Respeta Content-Disposition para el filename.
 */
export const descargarImpuestosExcel = async (filtros) => {
  let response
  try {
    response = await serviciosV2Client.get(`export/impuestos-detalle.xlsx`, {
      params: baseFiltros(filtros),
      responseType: "blob",
      timeout: 600000,
    })
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text()
        const json = JSON.parse(text)
        throw new Error(json.error || json.message || "Error al exportar.")
      } catch (parseErr) {
        if (parseErr instanceof Error && parseErr.message.startsWith("Error al exportar")) throw parseErr
      }
    }
    throw err
  }

  const cd = response.headers["content-disposition"] || ""
  const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i)
  const filename = match
    ? decodeURIComponent(match[1])
    : `impuestos-detalle_${filtros.nitemisor}_${filtros.fecha_inicio}_${filtros.fecha_fin}.xlsx`

  const contentType = response.headers["content-type"]
    || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

  const blob = new Blob([response.data], { type: contentType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)

  return {
    totalSucursales: Number(response.headers["x-total-sucursales"]) || null,
    totalDias: Number(response.headers["x-total-dias"]) || null,
    cache: response.headers["x-cache"] || null,
    filename,
  }
}
